import Cookies from 'js-cookie';
import SERVER_URL from '../env.js';
import { useState, useEffect } from 'react';

export function useAuthorization() {
    const [authInfo, setAuthInfo] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const access_token = Cookies.get('accessToken');
        if (!access_token) {
            setLoading(false);
            return;
        }

        fetch(SERVER_URL + '/auth/me', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + access_token,
            }
        })
            .then((res) => res.json())
            .then((data) => {
                if (!data.error) {
                    setAuthInfo(data);
                }
            })
            .catch((err) => {
                console.error('Failed to fetch auth info:', err);
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return { authInfo, loading };
}

export function logoutUser(navigate) {
    const refreshToken = Cookies.get('refreshToken');

    // Clear authentication cookies immediately
    Cookies.remove('accessToken');
    Cookies.remove('refreshToken');

    // Revoke session token in the database asynchronously
    if (refreshToken) {
        fetch(SERVER_URL + '/auth/logout', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ refreshToken }),
        })
            .then((res) => res.json())
            .then((data) => {
                console.log('Logged out from server:', data.message);
            })
            .catch((err) => {
                console.error('Error logging out from server:', err);
            });
    }

    // Redirect to login page
    if (navigate) {
        navigate('/login');
    } else {
        window.location.href = '/login';
    }
}
